import EVT from '@/utils/bus'

//Google登录成功返回数据
export interface GoogleLoginResponse {
    credential?: string //一键式登录返回
    access_token?: string //手动登录返回
}

//登录回调
// type LoginCallback = (resp: LoginData) => void

//登录数据
export interface LoginData {
    status: 'success' | 'failed'
    id?: number
    name?: string
    from: 'facebook' | 'google'
    avatar?: string
    accesstoken?: string
    client_id?: string //用于Google
}

export namespace H5Login {
    export const Google_Client_Id = '1062687261081-6hpoveitlbq5v1epipttres97jsgfeo7.apps.googleusercontent.com'
    export const FB_App_Id = '994888055307524'
    export const H5_Login_Back = 'H5_Login_Back'

    export function init() {
        initGoogleH5Login()
        initFacebookH5Login()
    }

    //-----------------google login-----------------
    //解析Google token
    export function decodeJwtResponse(token: string) {
        console.log('decodeJwtResponse--', token)

        let base64Url = token.split('.')[1]
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        let jsonPayload = decodeURIComponent(
            window
                .atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                })
                .join('')
        )
        console.log('jsonPayload--', jsonPayload)

        return JSON.parse(jsonPayload)
    }

    //添加Google登录按钮
    export function addGoogleLoginButton() {
        let divElement = document.querySelector('.g_id_signin')
        if (!divElement) {
            const div = document.createElement('div')
            div.className = 'g_id_signin'
            div.setAttribute('data-type', 'icon')
            div.setAttribute('data-shape', 'circle')
            div.setAttribute('data-theme', 'filled_blue')
            div.setAttribute('data-text', 'signin')
            div.setAttribute('data-size', 'small')
            div.style.display = 'none'

            document.body.appendChild(div)
        }
    }
    function handleGoogleSignIn(response: GoogleLoginResponse) {
        // 处理Google登录成功的响应
        const responsePayload = decodeJwtResponse(response.credential)
        const loginData: LoginData = {
            from: 'google',
            status: 'success',
            id: responsePayload.sub,
            name: responsePayload.name,
            accesstoken: response.credential,
            client_id: Google_Client_Id,
            avatar: responsePayload.picture,
        }
        EVT.emit(H5_Login_Back, loginData) //成功登录通知
    }

    /** 初始化GoogleH5登录
     * @param successCallback  Google登录成功回调
     * @param cancelCallback Google登录取消回调
     *
     */
    function initGoogleH5Login() {
        addGoogleLoginButton()
        const script = document.createElement('script')
        const handleGoogleSignInCancel = () => {
            // 处理Google登录取消
            const loginData: LoginData = {
                from: 'google',
                status: 'failed',
                client_id: Google_Client_Id,
            }
            EVT.emit(H5_Login_Back, loginData)
        }
        const initializeGoogleSignIn = (client_id: string) => {
            //@ts-ignore
            window.google.accounts?.id.initialize({
                client_id,
                use_fedcm_for_prompt: false,
                cancel_on_tap_outside: true, // 控制是否在提示之外进行点击时取消提示(关闭一键登录弹窗)，默认true
                auto_select: false, // 开启自动登录功能，默认false
                callback: handleGoogleSignIn, // 验证成功回调
                cancel: handleGoogleSignInCancel,
            })

            //@ts-ignore
            window.google.accounts?.id.renderButton(
                document.querySelector('.g_id_signin'),
                { theme: 'outline', size: 'large' } // customization attributes
            )
        }

        //@ts-ignore
        if (!window.google) {
            script.src = 'https://accounts.google.com/gsi/client' // 加载客户端库
            script.async = true
            script.onload = () => {
                initializeGoogleSignIn(Google_Client_Id)
            }

            document.head.appendChild(script)
        }
    }

    // 启用一键登录提示(弹窗)功能
    export function enableGoogleSignInPrompt() {
        // @ts-ignore
        window.google?.accounts.id.prompt((notification) => {
            console.log(notification, 'notification')
            console.log('notification.isNotDisplayed()--', notification.isNotDisplayed())
            console.log('notification.isSkippedMoment()--', notification.isSkippedMoment())
            // if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
            // @ts-ignore
            var divElement = document.querySelector('.g_id_signin')
            var buttonElement = divElement.querySelector('[role="button"]')
            if (buttonElement) {
                // @ts-ignore
                buttonElement.click() //有阻止弹出式弹窗的浏览器，此处无效
            } else {
                //@ts-ignore
                const client = window.google.accounts.oauth2.initTokenClient({
                    client_id: Google_Client_Id,
                    scope: 'openid email profile',
                    callback: getUserInfo,
                })
                client.requestAccessToken()
            }
        })
    }

    async function getUserInfo(response: GoogleLoginResponse) {
        let accessToken = response.access_token
        let userInfo = null
        try {
            const response = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            })

            if (response.ok) {
                userInfo = await response.json()
                const loginData: LoginData = {
                    from: 'google',
                    status: 'success',
                    id: userInfo.id,
                    name: userInfo.name,
                    accesstoken: accessToken,
                    client_id: '',
                }
                EVT.emit(H5_Login_Back, loginData)
                return
            } else {
                console.error('Failed to get user info:', response.status)
            }
        } catch (error) {
            console.error('Error getting user info:', error)
        }
        const loginData: LoginData = {
            from: 'google',
            status: 'failed',
            client_id: Google_Client_Id,
        }
        EVT.emit(H5_Login_Back, loginData)
    }

    //-----------------facebook login-----------------
    function initFacebookH5Login() {
        const script = document.createElement('script')
        script.src = 'https://connect.facebook.net/en_US/sdk.js'
        script.async = true
        script.onload = () => {
            //@ts-ignore
            FB.init({
                appId: FB_App_Id,
                xfbml: true,
                version: 'v20.0',
                cookie: true,
            })
        }
        document.head.appendChild(script)
    }

    /**
     * facebook登录
     * @param successCallback
     * @param cancelCallback
     */
    export function loginWithFacebook() {
        //@ts-ignore
        FB.login(
            function (resp: { authResponse: { accessToken: string } }) {
                if (resp.authResponse) {
                    //@ts-ignore
                    FB.api(
                        '/me',
                        { fields: 'name, id, picture' },
                        function (response: { picture?: { data: { url: string } }; id: number; name: string }) {
                            let avatar = response.picture ? response.picture.data.url : ''
                            const loginData: LoginData = {
                                from: 'facebook',
                                status: 'success',
                                id: response.id,
                                name: response.name,
                                avatar: avatar,
                                accesstoken: resp.authResponse.accessToken,
                            }
                            EVT.emit(H5_Login_Back, loginData)
                            //@ts-ignore
                            // FB.logout(function () {})
                        }
                    )
                } else {
                    const loginData: LoginData = {
                        from: 'facebook',
                        status: 'failed',
                    }
                    EVT.emit(H5_Login_Back, loginData)
                }
            },
            { scope: 'public_profile' }
        )
    }
    // facebook分享
    export function FBShare(params) {
        return new Promise((resolve) => {
            //@ts-ignore
            FB.ui(
                {
                    method: 'share',
                    ...params,
                },
                function (response) {
                    resolve(response)
                }
            )
        })
    }
}
